import React, { useEffect, useRef, useState } from "react";
import jsQR from "jsqr";
import { QrCode, CameraOff } from "lucide-react";

/** Scans an ID-card QR with the tablet camera; calls onCode(text) once per distinct code. */
export default function QrScanner({ onCode, paused }) {
  const vid = useRef(null); const canvas = useRef(document.createElement("canvas")); const last = useRef({ code: "", at: 0 });
  const [state, setState] = useState("starting");
  useEffect(() => {
    let stream, raf, alive = true;
    navigator.mediaDevices?.getUserMedia({ video: { facingMode: "environment", width: { ideal: 640 } }, audio: false })
      .then(s => { stream = s; if (!alive) return; vid.current.srcObject = s; vid.current.play().catch(() => {}); setState("live");
        const tick = () => {
          if (!alive) return; const v = vid.current;
          if (v && v.readyState === 4 && !paused) {
            const c = canvas.current; c.width = v.videoWidth; c.height = v.videoHeight; const ctx = c.getContext("2d", { willReadFrequently: true }); ctx.drawImage(v, 0, 0);
            const img = ctx.getImageData(0, 0, c.width, c.height); const q = jsQR(img.data, c.width, c.height, { inversionAttempts: "dontInvert" });
            if (q?.data && (q.data !== last.current.code || Date.now() - last.current.at > 4000)) { last.current = { code: q.data, at: Date.now() }; onCode?.(q.data); }
          }
          raf = setTimeout(tick, 250);
        }; tick(); })
      .catch(() => setState("denied"));
    return () => { alive = false; clearTimeout(raf); stream?.getTracks().forEach(t => t.stop()); };
  }, []); // eslint-disable-line
  return (
    <div className="relative bg-black aspect-video overflow-hidden border border-zinc-800" data-testid="kiosk-qr">
      <video ref={vid} muted playsInline className={`w-full h-full object-cover ${state === "live" ? "" : "hidden"}`} />
      {state === "live" ? <div className="absolute inset-0 grid place-items-center pointer-events-none"><div className="w-40 h-40 border-2 border-emerald-400/80" /></div> : <div className="absolute inset-0 grid place-items-center text-center p-4 text-zinc-400 text-xs">{state === "denied" ? <><CameraOff size={20} className="mx-auto mb-1" />Camera unavailable — tap your name instead</> : <><QrCode size={20} className="mx-auto mb-1" />Starting camera…</>}</div>}
      <div className="absolute bottom-1 left-1 text-[10px] bg-black/60 px-1.5 py-0.5 text-zinc-300 flex items-center gap-1"><QrCode size={10} /> Scan your ID card to check in</div>
    </div>
  );
}
